import * as types from '../constants';

const INITIALSTATE = {
  checkout: {},
  confirmation: {}
};

export default function checkout(state = INITIALSTATE, action) {
  const st = Object.assign({}, state);

  switch (action.type) {
    case types.GET_CHECKOUT:
      st.checkout = action.payload;
      delete st.err;
      return st;

    case types.FINALIZE_CHECKOUT:
      const confirmation = {
        orderID: action.payload.order.order_id,
        orderTime: action.payload.order.order_date,
        completedReservations: action.payload.order.reservations,
        subtotal: action.payload.order.subtotal,
        discount: action.payload.order.discount,
        tax: action.payload.order.tax,
        total: action.payload.order.total,
        transactions: action.payload.order.transactions,
        modification: action.payload.modification
      };
      st.confirmation = confirmation;
      delete st.err;
      return st;

    case types.FINALIZE_NOFEE:
        let mod = false;
        if ( action.payload.modification ) {
            mod = true;
        }
        const noFeeconfirmation = {
            orderID: action.payload.order_id,
            orderTime: action.payload.order_date,
            completedReservations: action.payload.reservations,
            subtotal: action.payload.subtotal,
            discount: action.payload.discount,
            tax: action.payload.tax,
            total: action.payload.total,
            modification: mod
        };
        st.confirmation = noFeeconfirmation;
        delete st.err;
        return st;

    case types.FINALIZE_CHECKOUT_ERROR:
        st.err = types.FINALIZE_CHECKOUT_ERROR;
        return st;

    case types.FETCH_CHECKOUT_ERROR:
        st.err = types.FINALIZE_CHECKOUT_ERROR;
        return st;

    default:
      return st;
  }
}
